export const uploadReducer = {};
